import type { IChannel } from "../types/chat";

/**
 * Stable key for channels when `id` may be missing (fallback to `name`).
 * Returns "" when neither id nor name is set.
 */
export function channelKey(c: IChannel | null | undefined): string {
  if (c == null) {
    return "";
  }
  return c.id != null || c.name != null ? String(c.id ?? c.name) : "";
}
